import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'

import App from './App'
import { createAppQueryClient } from './lib/queries/query-client'
import { installBrowserErrorReporting } from './lib/utils/browser-errors'
import { log, logWelcome } from './lib/utils/log'

const removeBrowserErrorReporting = installBrowserErrorReporting()
if (import.meta.hot) import.meta.hot.dispose(removeBrowserErrorReporting)

logWelcome()
log('Frontend environment ready', 'env', {
  stage: import.meta.env.VITE_STAGE ?? 'local',
  apiUrl: import.meta.env.VITE_API_URL || 'same origin'
})

// Create a client
const queryClient = createAppQueryClient()

const rootElement = document.getElementById('root') as HTMLElement

if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
)
